import React from "react";
import { Section, sectionSpacingY } from "components/section";
import { Accordion } from "ui/accordion";
import { TextTitle } from "ui/text";

export function Faq() {
  return (
    <Section my={0} pt={{ base: "biggest", md: "huger" }} pb={sectionSpacingY}>
      <TextTitle size="lg" align="center" title="FAQs" />

      <Accordion
        maxWidth="3xl"
        mx="auto"
        mt={{ base: "big", md: "biggest" }}
        items={[
          {
            title: "Does AI Decisioning share data or learnings across companies?",
            content:
              "No. AI Decisioning never stores any of your data and it doesn’t share data across customer environments. The only data it can see is what you expose from your data warehouse.",
          },
          {
            title: "Does AI Decisioning work with my existing e-mail, SMS, or push tool?",
            content:
              "Yes. AI Decisioning works with your existing lifecycle tools like Salesforce Marketing Cloud, Iterable, or Braze. Not sure if your tool is supported? Just ask.",
          },
          {
            title: "Is AI Decisioning a “black box?”",
            content:
              "No. Every messaging decision and experiment is logged transparently both in the Hightouch UI and in a log in your data warehouse.",
          },
          {
            title: "Is AI Decisioning compatible with my existing data science projects?",
            content:
              "Yes. AI Decisioning can reference existing models and data science projects. If it’s in your data warehouse, then it can be used in AI Decisioning.",
          },
          {
            title: "What are common use cases to start with AI Decisioning?",
            content:
              "Most companies start with existing high send volume sequences or campaigns that they feel are under-performing their potential. These are often triggered drips, or regular large scale sends designed to drive up customer loyalty or lifetime value.",
          },
        ]}
      />
    </Section>
  );
}
